import React, {useState} from 'react';
import axios from "axios";
import parse from "html-react-parser";
import { mrbgStore } from './mrbg/mrbgRedux/index.js'

function ContactUsForm({mainStyle}){

  const
    [msg,setMsg] = useState(''),
    handleSubmit = (e) => {
    e.preventDefault();
      var MD = new FormData(e.target.closest('form'));

      if( document.getElementByDataID('mrbgLoader') )
        document.getElementByDataID('mrbgLoader').style.display='block';

      axios(
        {
          url: `${mrbgStore.getState().url}/Api/Dispatcher.php${window.location.search}`,
          method: 'POST',
          headers: {
            MrbgTk  : localStorage.getItem('token'),
            MrbgOr  : 'mailTo',
            MrbgOp  : 'mailTo',
            MrbgPath: window.location.pathname
          },
          data: MD
        }
      )
        .then (res=>{
          if( document.getElementByDataID('mrbgLoader') )
            document.getElementByDataID('mrbgLoader').removeAttribute('style');
          setMsg( res.data )
        });
  };

  return(
    <section id={mainStyle.contactUsSec} className={mainStyle.prl_Y}>
      <div id={mainStyle.contactUsFrame}>
        <div id={mainStyle.h2Frame}>
          <h2>contact with us</h2>
          <div>{`Stay with ${mrbgStore.getState().enTitle.replace(/\b\w/g, char => char.toUpperCase())}.`}</div>
        </div>
        <div  className={mainStyle.flexRowDesk}>
          <form id={mainStyle.contactUsForm} onSubmit={e=>handleSubmit(e)}>
            <fieldset>
              <input type="text" name="fullName" placeholder="full name" autoComplete="off" required/>
            </fieldset>
            <fieldset>
              <input type="tel" name="phone" placeholder="phone" autoComplete="off" required/>
            </fieldset>
            <fieldset>
              <input type="mail" name="mail" placeholder="mail" autoComplete="off" required/>
            </fieldset>
            <fieldset>
              <textarea placeholder="Your Message" rows={4} required></textarea>
            </fieldset>
            <div className={mainStyle.blogFormMsgBox}>
              {parse(msg)}
            </div>
            <fieldset>
              <button type="submit">Send</button>
            </fieldset>
          </form>
          <figure id={mainStyle.contactUsFigure}></figure>
        </div>
      </div>
    </section>
  )
}

export default ContactUsForm;